export default __webpack_public_path__ + "static/media/abz-web-logo.40f46cf4.png";